// @owners { team: patient-fulfillment }
// eslint-disable-next-line @alto/no-pocky-import
import { Loader, SimpleContainer, SimpleContainerHeader, SimpleContainerSection } from '@alto/pocky';
import autobind from 'autobind-decorator';
import React, { PureComponent } from 'react';
import { type ModalType } from '~shared/actions/modal';
import { type Insurance as InsuranceType } from '~shared/types/clients';
import CashPayInsurance from '~web/features/insurances/components/CashPayInsurance';
import EmptyInsurance from '~web/features/insurances/components/EmptyInsurance';
import InsuranceList from '~web/features/insurances/components/InsuranceList';

export type Props = {
  readonly fetchInsurances: () => Promise<boolean>;
  readonly isFetchInsurancesLoading: boolean;
  readonly insurances: InsuranceType[];
  readonly isNeedsInsurance: boolean;
  readonly isCashPayOnly: boolean;
  readonly openModal: (modalType: ModalType, props?: Record<string, unknown>) => void;
  readonly selectUser: (userID: number) => void;
  readonly updateCashPay: () => void;
  readonly userID: number;
};

export default class ProfileInsurances extends PureComponent<Props> {
  componentDidMount() {
    const { fetchInsurances } = this.props;
    fetchInsurances();
  }

  // @ts-expect-error error TS1270: Decorator function return type 'void | TypedPropertyDescriptor<unknown>' is not assignable to type 'void | (() => void)'
  @autobind
  handleAddInsurance() {
    const { openModal, selectUser, userID } = this.props;

    selectUser(userID);
    openModal('INSURANCE_MODAL');
  }

  renderContent() {
    const { insurances, isNeedsInsurance, isFetchInsurancesLoading, updateCashPay, isCashPayOnly } = this.props;

    if (isFetchInsurancesLoading) {
      return <Loader text="Loading your insurances..." />;
    }

    if (isCashPayOnly) {
      return (
        <SimpleContainerSection>
          <CashPayInsurance
            // eslint-disable-next-line @typescript-eslint/unbound-method
            onAddInsurance={this.handleAddInsurance}
            inlineButton
          />
        </SimpleContainerSection>
      );
    }

    if (isNeedsInsurance) {
      return (
        <SimpleContainerSection>
          <EmptyInsurance
            // eslint-disable-next-line @typescript-eslint/unbound-method
            onAddInsurance={this.handleAddInsurance}
            onSelectCashPay={updateCashPay}
            inlineButton
          />
        </SimpleContainerSection>
      );
    }

    return (
      <SimpleContainerSection>
        <InsuranceList
          insurances={insurances}
          // eslint-disable-next-line @typescript-eslint/unbound-method
          onAddInsurance={this.handleAddInsurance}
        />
      </SimpleContainerSection>
    );
  }

  render() {
    return (
      <SimpleContainer>
        <SimpleContainerHeader>Insurance</SimpleContainerHeader>
        {this.renderContent()}
      </SimpleContainer>
    );
  }
}
